var lib_core = require("lib-core");

/**
 * @constructor
 */
var ToolbarStateMachine = function (root, model) {
    var self = this;
    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(this);

    this.addEventAction(/.*/,
        function(cEvent){
            return (cEvent.isKeyPressed('m'));
        },
        function(cEvent){
            var index = self.model.modes.indexOf(self.model.activeMode());
            var cycledIndex = (index+1)%self.model.modes.size();
            self.model.activeMode(self.model.modes.get(cycledIndex));
        }
    );

    this.addEventAction(/.*/,
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.TOOLBAR_SWITCH_MODE;
        },
        function(cEvent){
            var index = 0;
            self.model.modes.forEach(function (idx, mode) {
                if(mode.name() === cEvent.data('name')) index = idx;
            });
            self.model.activeMode(self.model.modes.get(index));
        }
    );
};
lib_core.inherit(ToolbarStateMachine, lib_core.StateMachine);

module.exports = ToolbarStateMachine;

ToolbarStateMachine.prototype.registerTool = function (name, autoEscape, enterFunction, exitFunction) {
    var self = this;

    // Select a tool
    this.addTransition("idle", name,
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.SET_TOOL && cEvent.data('tool') == name;
        },
        function(cEvent){
            self.model.activeTool(cEvent.data('tool'));
            enterFunction(cEvent);
        }
    );

    // Deselect a tool
    this.addTransition(name, "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.SET_TOOL;
        },
        function(cEvent){
            exitFunction(cEvent);
            if (cEvent.data('tool') == name || cEvent.data('tool') == 'idle')
                self.model.activeTool("idle");
            else
                self.handle(cEvent);
        }
    );

    // Escape removes the tool
    this.addTransition(name, "idle",
        function (cEvent) { return cEvent.isKeyPressed('escape'); },
        function(cEvent){
            exitFunction(cEvent);
            self.model.activeTool("idle");
        }
    );

    if(autoEscape) {
        this.addTransition(name, "idle",
            function (cEvent) {
                return cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP;
            },
            function(cEvent){
                exitFunction(cEvent);
                self.model.activeTool("idle");
            }
        );
    }

    // return to idle state if non-tool features are selected
    this.addTransition(name, "idle",
        function(cEvent){
            return (cEvent.type().isGuiButton &&
                    cEvent.type() != lib_core.GuiEvents.SET_TOOL) ||
                    cEvent.isKeyPressed('C_z', 'C_y');
        },
        function(cEvent){
            exitFunction(cEvent);
            self.model.activeTool("idle");
            self.handle(cEvent);
        }
    );
};
